import { useContext } from 'react';

import { L10nContext } from 'context/L10nContext';

import { AsyncReducerStatus } from 'store/common/AsyncReducerStatus';
import { useTypedSelector } from 'store/common/TypedSelector';

import { ModalDialogueHeader } from 'presentation/ui/compositions/modal-dialogue/modal-dialogue-header/ModalDialogueHeader';
import { ModalDialogueSection } from 'presentation/ui/compositions/modal-dialogue/modal-dialogue-section/ModalDialogueSection';
import { ModalDialogue } from 'presentation/ui/compositions/modal-dialogue/ModalDialogue';
import { IconIdentifier } from 'presentation/ui/partials/icon/IconIdentifier';
import { MembershipCreateFailedNotification } from './MembershipCreateFailedNotification';
import { MembershipCreateSuccessNotification } from './MembershipCreateSuccessNotification';
import { MembershipCreateForm } from '../membership-create-form/MembershipCreateForm';

interface MembershipCreateModalProps {
	/**
	 * onDismiss
	 */
	onDismiss: () => void;
}

/**
 * The membership create modal
 */
export const MembershipCreateModal = (props: MembershipCreateModalProps): JSX.Element => {
	const { onDismiss } = props;

	// Consume the context
	const l10nContext = useContext(L10nContext);

	// Use selector to provide information from store
	const membershipActionStatus = useTypedSelector(state => state.memberships.actionStatus);

	const renderModal = () => {
		let modal: JSX.Element = null;

		switch (membershipActionStatus) {
			case AsyncReducerStatus.IDLE:
				modal = <MembershipCreateForm />;
				break;

			case AsyncReducerStatus.CREATED:
				modal =
					<MembershipCreateSuccessNotification
						onClickConfirm={onDismiss}
					/>;
				break;

			case AsyncReducerStatus.FAILED:
				modal =
					<MembershipCreateFailedNotification
						onClickConfirm={onDismiss}
					/>;
				break;
		}
		return modal;
	};

	return (
		<ModalDialogue onDismiss={onDismiss}>
			<ModalDialogueHeader
				captionText={l10nContext.translate('view.memberships.modal.action.add.caption', 'Zugriff gewähren')}
				captionIcon={IconIdentifier.ADD}
			/>
			<ModalDialogueSection>
				{renderModal()}
			</ModalDialogueSection>
		</ModalDialogue>
	);
};
